import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AngularFireStorage } from '@angular/fire/storage/';
import { AngularFireFunctions } from '@angular/fire/functions';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrencyPipe } from '@angular/common';
@Component({
  selector: 'app-uplatnica-dialog',
  templateUrl: './uplatnica-dialog.component.html',
  styleUrls: ['./uplatnica-dialog.component.scss']
})
export class UplatnicaDialogComponent implements OnInit {
  uplatniceFiles: File[];
  uploadedImageUnsafeBase64: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storage: AngularFireStorage,
    private fsFunc: AngularFireFunctions,
    private sanitizer: DomSanitizer,
    private ngZone: NgZone) {
    console.log(data)
    if (data.order.numOfMonths == undefined) data.order.numOfMonths = 1
    if (data.order.payments) {
      for (let i = 0; i < data.order.payments.length; i++)
        data.order.payments[i].paymentIndex = i
    } else {
      data.order.payments = [];
      for (let i = 0; i < data.order.numOfMonths; i++)
        data.order.payments.push({
          paymentIndex: i
        })
    }
    data.order.payments.forEach((payment) => {
      payment.qrBase64 = 'assets/images/loading.svg';
      fsFunc.httpsCallable('order-makeQRCode')({
        amount:  data.order.monthlyFee,
        purpose: `${data.user.indeks} - ${data.user.displayName} - ${payment.paymentIndex + 1}. rata`,
      }).subscribe(response => {
        ngZone.run(() => {
          payment.qrBase64 = sanitizer.bypassSecurityTrustUrl(response.base64);
        })
      })
    })

    data.user.indeks = data.user.indeks.replace(/[^\w\s]/gi, '');
  }

  ngOnInit(): void {
  }
  async uploadUplatnica() {
    console.log(this.data);
    try {
      for (let u of this.uplatniceFiles) {
        var metadata = {
          contentType: u.type
        };
        await this.storage.ref(`users/${this.data.user.id}/orders/${this.data.order.id}/${u.name}`)
          .put(u, metadata);
      }
      alert("Uplatnica je uploadovana. Bićete obavešteni kada uplata bude evidentirana. :)")
    } catch (err) {
      console.log(err);
      alert("GRESKA. :( Pokusaj ponovo ili kontaktiraj podrsku")
    }
  }
  async fileChangeEvent(e) {
    var count = 1;
    var files = e.currentTarget.files; // puts all files into an array
    this.uplatniceFiles = [];

    // call them as such; files[0].size will get you the file size of the 0th file
    for (var x in files) {
      var filesize: number = parseInt(((files[x].size / 1024) / 1024).toFixed(4)); // MB
      if (files[x].name != "item" && typeof files[x].name != "undefined") {
        if (filesize <= 5) {
          var fr = new FileReader();
          fr.onload = () => {
            this.uploadedImageUnsafeBase64 = fr.result.toString().replace(/.*,/, "");
          };
          fr.readAsDataURL(files[x]);
          this.uplatniceFiles.push(files[x]);
        } else {
          alert("MAX 5MB")
        }
      }
    }
  }

}
